import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { rutClean, rutFormat, RutValidator } from 'src/app/utils/rut.directive';
import { matchOtherValidator } from 'src/app/utils/validators/match-other-validator';
import { UsuarioGeneratePassComponent } from '../usuario-generate-pass/usuario-generate-pass.component';
import { UsuarioService } from '../usuario.service';

@Component({
  selector: 'app-usuario-create',
  templateUrl: './usuario-create.component.html',
  styleUrls: ['./usuario-create.component.scss']
})
export class UsuarioCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: UsuarioService,
    public formatter: FormatterService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      nombre: ['', [Validators.required]],
      apellido: ['', [Validators.required]],
      rut: ['', [RutValidator()]],
      fono: [null],
      password: ['', [Validators.required]],
      repeatPass: ['', [Validators.required, matchOtherValidator('password')]],
      rol_id: ['', [Validators.required]],
    });
  }

  changed_rut(element: any) {
    let htmlInputElement: HTMLInputElement = <HTMLInputElement>element.target;
    htmlInputElement.value = rutFormat(htmlInputElement.value) || '';
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      if (this.form.value.rut) {
        let rut = rutClean(this.form.value.rut);
        this.form.controls['rut'].setValue(rut);
      }
      this.service.insert(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Usuario registrado con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de usuario.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  generatePass(): void {
    const modalRef = this.modalService.open(UsuarioGeneratePassComponent, { size: 'sm', centered: true });
    modalRef.result.then((result) => {
      this.form.patchValue({ password: result, repeatPass: result });
    }, (reason) => { });
  }
}
